import { createAction } from 'redux-actions'
import { FAQS } from '../testData/faqs'

const SET_FAQS = 'SET_FAQS'

const setFaqs = createAction(SET_FAQS)

export const getFaqs = () => {
    return (dispatch) => {
        dispatch(setFaqs({ items: FAQS }))
    }
}

const INITIAL_STATE = {
    items: {},
}

const ACTION_HANDLERS = {
    [SET_FAQS]: (state, { payload }) => {
        let itemsByCategory = {}

        payload.items.forEach(function (item) {
            const platform = item.platform.toLowerCase()
            if (itemsByCategory[platform]) {
                itemsByCategory[platform].push(item)
            } else {
                itemsByCategory[platform] = [ item ]
            }
        })

        return {
            ...state,
            items: itemsByCategory,
        }
    },
}

export default (state = INITIAL_STATE, action) => {
    const handler = ACTION_HANDLERS[action.type]
    return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/reducers/faqs.js